import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { mapDispatchSet } from '../../utils/redux';

export const calendarSlice = createSlice({
  name: "calendar",
  initialState: {
    hoveringFormId: "",
    loading: false,
  },
  reducers: {
    setHoveringFormId: (state, action: PayloadAction<string>) => {
      state.hoveringFormId = action.payload;
    },
    unsetHoveringFormId: (state, action: PayloadAction<string>) => {
      if (!action.payload || action.payload === state.hoveringFormId) {
        state.hoveringFormId = "";
      }
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const actions = mapDispatchSet(calendarSlice.actions);
